var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarSystemButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.5,
    height: 82.892,
    viewBox: "0 0 79.5 82.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_189",
    x: 0,
    y: 4.077,
    width: 64.005,
    height: 78.815,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_190",
    x: 9.089,
    y: 12.489,
    width: 59.771,
    height: 53.39,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_191",
    x: 32.205,
    y: 4.735,
    width: 47.295,
    height: 68.088,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_192",
    x: 21.406,
    y: 0,
    width: 39.066,
    height: 39.08,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_193",
    x: 34.725,
    y: 23.622,
    width: 39.066,
    height: 39.068,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_194",
    x: 34.725,
    y: 42.346,
    width: 39.066,
    height: 39.069,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_195",
    x: 11.913,
    y: 35.533,
    width: 39.065,
    height: 39.065,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_196",
    x: 20.474,
    y: 21.589,
    width: 40.845,
    height: 43.147,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_197",
    x: 22.174,
    y: 34.364,
    width: 46.684,
    height: 39.451,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_198",
    x: 15.865,
    y: 25.284,
    width: 36.866,
    height: 36.856,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ZgmNRL",
    transform: "translate(-132.747 867.831)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189-2",
    "data-name": "Path 189",
    d: "M172.23-765.24a22.565,22.565,0,0,0,7.875-1.329c.153-.055.307-.11.458-.172.1-.041.154-.018.194.086a6.68,6.68,0,0,0,.946,1.71c.1.131.028.161-.078.205a20.778,20.778,0,0,1-2.438.834,24.964,24.964,0,0,1-4.985.864,24.426,24.426,0,0,1-7.3-.573,24.452,24.452,0,0,1-8.812-4,24.846,24.846,0,0,1-3.216-2.754,24.627,24.627,0,0,1-4.664-6.6,24.341,24.341,0,0,1-2.173-6.992,24.687,24.687,0,0,1-.286-4.287,24.363,24.363,0,0,1,1.409-7.634,25.141,25.141,0,0,1,2.806-5.561,25.2,25.2,0,0,1,2.36-2.993,24,24,0,0,1,2.522-2.385,24.912,24.912,0,0,1,6.142-3.714,25.386,25.386,0,0,1,3.781-1.241c.195-.048.244-.016.233.189a5.3,5.3,0,0,0,.173,1.774c.056.194,0,.258-.185.305a21.87,21.87,0,0,0-6.123,2.58,22.686,22.686,0,0,0-5.686,4.939A22.6,22.6,0,0,0,151-794.263a22.032,22.032,0,0,0-.886,4.4,21.719,21.719,0,0,0-.025,4.106,22.323,22.323,0,0,0,3.278,9.856,22.24,22.24,0,0,0,3.882,4.7,22.374,22.374,0,0,0,7.8,4.7,22.454,22.454,0,0,0,4.423,1.069A18.735,18.735,0,0,0,172.23-765.24Z",
    transform: "translate(-132.75 830.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_190)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190-2",
    "data-name": "Path 190",
    d: "M241.518-711.661a13.438,13.438,0,0,0,1.411,6.217c.1.2.107.305-.106.438a5.512,5.512,0,0,0-1.329,1.188c-.123.151-.189.14-.281-.029a15.692,15.692,0,0,1-1.668-4.609,15.252,15.252,0,0,1-.289-3.261,15.7,15.7,0,0,1,1.462-6.326,15.545,15.545,0,0,1,3.572-4.892,15.4,15.4,0,0,1,7.717-3.891,15.525,15.525,0,0,1,7.619.452,15.429,15.429,0,0,1,6.214,3.719,15.453,15.453,0,0,1,3.1,4.277c.137.278.132.276-.176.3a5.687,5.687,0,0,0-1.714.405c-.182.076-.27.04-.365-.136a13.192,13.192,0,0,0-5-5.2,12.946,12.946,0,0,0-4.941-1.709,13.047,13.047,0,0,0-8.736,1.8,13.229,13.229,0,0,0-6.287,9.121A10.436,10.436,0,0,0,241.518-711.661Z",
    transform: "translate(-215.16 754.59)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191-2",
    "data-name": "Path 191",
    d: "M489.254-781.683a24.874,24.874,0,0,1-1.571,8.6,25.569,25.569,0,0,1-2.872,5.479c-.1.152-.224.294-.33.445-.078.111-.147.119-.23.009a6.519,6.519,0,0,0-1.4-1.336c-.122-.089-.07-.157-.008-.245a22.27,22.27,0,0,0,1.989-3.4,22.487,22.487,0,0,0,1.928-6.4,22.618,22.618,0,0,0,.194-4.443,21.872,21.872,0,0,0-1.31-6.4,22.574,22.574,0,0,0-3.309-6.03,21.739,21.739,0,0,0-2.346-2.615,22.381,22.381,0,0,0-7.866-4.857c-.163-.058-.2-.116-.138-.29a5.361,5.361,0,0,0,.361-1.766c.006-.252.017-.258.257-.175a24.679,24.679,0,0,1,6.314,3.279,24.559,24.559,0,0,1,3.733,3.3,24.814,24.814,0,0,1,3.978,5.747,24.68,24.68,0,0,1,2.313,7.192A25.728,25.728,0,0,1,489.254-781.683Z",
    transform: "translate(-424.75 824.9)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192-2",
    "data-name": "Path 192",
    d: "M363.244-848.31a4.506,4.506,0,0,1,4.506-4.521,4.529,4.529,0,0,1,4.557,4.462,4.53,4.53,0,0,1-4.531,4.619A4.51,4.51,0,0,1,363.244-848.31Z",
    transform: "translate(-326.84 867.83)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193-2",
    "data-name": "Path 193",
    d: "M506.393-610.487a4.517,4.517,0,0,1-4.517,4.534,4.563,4.563,0,0,1-4.548-4.546,4.559,4.559,0,0,1,4.55-4.522A4.506,4.506,0,0,1,506.393-610.487Z",
    transform: "translate(-447.6 653.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194-2",
    "data-name": "Path 194",
    d: "M506.4-422a4.516,4.516,0,0,1-4.542,4.549,4.565,4.565,0,0,1-4.523-4.527,4.566,4.566,0,0,1,4.554-4.542A4.516,4.516,0,0,1,506.4-422Z",
    transform: "translate(-447.61 483.87)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195-2",
    "data-name": "Path 195",
    d: "M276.739-490.538a4.525,4.525,0,0,1-4.9,4.482,4.514,4.514,0,0,1-4.158-4.712,4.5,4.5,0,0,1,4.654-4.338A4.521,4.521,0,0,1,276.739-490.538Z",
    transform: "translate(-240.76 545.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196-2",
    "data-name": "Path 196",
    d: "M358.079-633.232a3.84,3.84,0,0,0-1.8.411.229.229,0,0,1-.27-.031,5.594,5.594,0,0,0-1.991-.94c-.057-.014-.145,0-.158-.082s.068-.1.115-.14a6.441,6.441,0,0,1,3.639-1.459,6.326,6.326,0,0,1,3.968.958,6.4,6.4,0,0,1,3,4.365,6.472,6.472,0,0,1-2.982,6.785,6.42,6.42,0,0,1-6.469.273c-.067-.033-.173-.05-.172-.138s.1-.084.164-.114a5.383,5.383,0,0,0,1.631-1.215.447.447,0,0,1,.478-.162,4.223,4.223,0,0,0,3.859-1.089,4.29,4.29,0,0,0,.384-5.831A4.416,4.416,0,0,0,358.079-633.232Z",
    transform: "translate(-318.39 672.08)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197-2",
    "data-name": "Path 197",
    d: "M373.276-497.431a14.673,14.673,0,0,1-2.151-.2c-.163-.028-.192-.071-.1-.215a6,6,0,0,0,.718-1.77c.031-.137.087-.184.234-.168a14,14,0,0,0,3.674-.073,13.18,13.18,0,0,0,5.654-2.3,13.114,13.114,0,0,0,3.916-4.383c.223-.4.218-.4.637-.252a5.714,5.714,0,0,0,1.577.342c.26.017.273.037.154.277a15.668,15.668,0,0,1-2.973,4.16,15.4,15.4,0,0,1-4.91,3.323,15.338,15.338,0,0,1-4.733,1.182C374.479-497.463,373.99-497.429,373.276-497.431Z",
    transform: "translate(-333.8 556.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 132.75, -867.83)",
    filter: "url(#Path_198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198-2",
    "data-name": "Path 198",
    d: "M310.9-591.442a3.422,3.422,0,0,1-3.434-3.44,3.448,3.448,0,0,1,3.428-3.415,3.451,3.451,0,0,1,3.438,3.463A3.43,3.43,0,0,1,310.9-591.442Z",
    transform: "translate(-276.6 638.58)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarSystemButtonIcon);
export default __webpack_public_path__ + "static/media/solar-system-button-icon.273bba815c18eaf3a6acee6c0a4af6b7.svg";
export { ForwardRef as ReactComponent };